import { render, staticRenderFns } from "./ModalProduct.vue?vue&type=template&id=454d019e&scoped=true"
import script from "./ModalProduct.vue?vue&type=script&lang=js"
export * from "./ModalProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalProduct.vue?vue&type=style&index=0&id=454d019e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454d019e",
  null
  
)

export default component.exports